// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function TableDatetimeCell(props) {
  let value = props.value;
  let formattedDate = I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, value);
  let match = I18n.dateTimeFormat(undefined, undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, value);
  let formattedTime = I18n.locale === "fr-FR" ? match.replace(":", "h") : match;
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(TextStyle.make, {
        children: formattedDate
      }),
      JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("at") + (" " + formattedTime),
        variation: "normal",
        size: "xxsmall"
      })
    ]
  });
}

let make = React.memo(TableDatetimeCell);

export {
  make,
}
/* make Not a pure module */
